import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Analytics } from '@vercel/analytics/react';

import { queryClient } from '@/lib/queryClient';
import { env } from '@/env';
import { AppRouter } from '@/router/AppRouter';
import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundary';
import { RootErrorFallback } from '@/components/ErrorBoundary/RootErrorFallback';

import '@/styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found in index.html');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ErrorBoundary fallback={<RootErrorFallback />}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        {env.ENABLE_DEVTOOLS && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </ErrorBoundary>
    <Analytics />
  </React.StrictMode>,
);
